import useCommon from '@hooks/useCommon.js';
import { deepSignal } from 'deepsignal';
import { CHARITY } from '@util/const.js';
import {
  LifetimeOverlay,
  LifetimeOverlayBackgroundColors,
  toLifetimeOverlayBackgroundColor,
} from '@playlive/overlay-core/overlays/lifetime';
import ScaledOverlayWrapper from '@components/overlays/wrapper/scaled-overlay-wrapper.jsx';
import HorizontalCustomizeWrapper from '@components/overlays/wrapper/horizonal-customize-wrapper.jsx';
import CustomizeSection from '@components/overlays/shared/customize-section.jsx';
import Description from '@components/overlays/shared/description.jsx';
import { formatColorName } from '@util/common.js';
import ColorPicker from '@components/pickers/color-picker/color.picker.jsx';
import LinkSetup from '@components/overlays/shared/link-setup.jsx';

const config = deepSignal({
  charityType: CHARITY.TILTIFY,
  bgColor: 'default-red',
});

export default function LifetimeRaisedPage() {
  const { overlayInfo, overlayURL, setConfigState } = useCommon({
    config,
    forceTiltify: true,
    addTiltifyCampaign: false,
  });

  function filterColors(color) {
    return LifetimeOverlayBackgroundColors.find((c) => c === color);
  }

  return (
    <div className="w-full overflow-x-hidden">
      <div className="flex flex-col xl:flex-row overflow-x-hidden">
        <div className="example_overlay select-none overflow-x-hidden w-full">
          <ScaledOverlayWrapper allowScaling={false} defaultScale="scale-100">
            <LifetimeOverlay
              backgroundColor={toLifetimeOverlayBackgroundColor(config.bgColor)}
              currentAmount={1000}
            />
          </ScaledOverlayWrapper>
        </div>

        <HorizontalCustomizeWrapper>
          <CustomizeSection title="Choose Colors">
            <span className="label-text mb-2">
              Background color: <b>{formatColorName(config.bgColor)}</b>
            </span>

            <ColorPicker
              fieldName="bgColor"
              currentColor={config.bgColor}
              filterFunction={filterColors}
              onChange={setConfigState}
            />
          </CustomizeSection>

          {/* Charity Section Placeholder */}
        </HorizontalCustomizeWrapper>
      </div>

      <Description>
        <p className="pb-4">
          Showcase your lifetime fundraising total for St. Jude with this
          dynamic overlay. Effortlessly display your cumulative achievements to
          your viewers, enhancing engagement and highlighting your impact on the
          kids and their families at St. Jude.
        </p>
      </Description>

      <div className="w-full xl:mt-4">
        <LinkSetup
          showTiltifyCampaignSelector={false}
          constrainWidth={false}
          charityType={CHARITY.TILTIFY}
          obsDimensions={overlayInfo.obsDimensions}
          overlayName={overlayInfo.name}
          overlayURL={overlayURL}
        />
      </div>
    </div>
  );
}
